import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'ngx-date-time-picker',
  templateUrl: './date-time-picker.component.html',
  styleUrls: ['./date-time-picker.component.scss']
})
export class DateTimePickerComponent implements OnInit {
  @Input() label: string = 'Select Date & Time';
  @Input() initialDate: Date = new Date();
  @Output() dateTimeChange = new EventEmitter<Date>();

  selectedDate: Date;
  selectedTime: string = '';

  ngOnInit() {
    this.selectedDate = new Date(this.initialDate);
    this.selectedTime = this.formatTime(this.selectedDate);
    this.emitCombinedDateTime();
  }

  private formatTime(date: Date): string {
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  }

  emitCombinedDateTime() {
    if (!this.selectedDate || !this.selectedTime) return;

    const [h, m] = this.selectedTime.split(':').map(Number);
    const result = new Date(this.selectedDate);
    result.setHours(h, m, 0, 0);
    this.dateTimeChange.emit(result);
  }

  get displayValue(): string {
    const result = new Date(this.selectedDate);
    const [h, m] = this.selectedTime.split(':').map(Number);
    result.setHours(h, m);
    return result.toLocaleString();
  }
}